import { useServicesContext } from '../../contexts/ServicesContext';
import { useQuery } from '@tanstack/react-query';

export enum CacheKey {
  GetAllTeamsWithinOrganization = 'GetAllTeamsWithinOrganization',
}

export const useGetTeamsWithinOrganizationQuery = () => {
  const { getTeamsWithinOrganization } = useServicesContext();

  return useQuery({
    queryKey: [CacheKey.GetAllTeamsWithinOrganization],
    queryFn: getTeamsWithinOrganization,
  });
};
